import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { WHATSAPP_DISPLAY, whatsappLink } from "@/constants/site";
import { solucoesCta } from "@/mocks/solucoes";

export default function SolucoesCta() {
  return (
    <section className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="absolute inset-0 nx-grid opacity-30"></div>
      <div className="nx-glow absolute left-1/2 top-0 h-[480px] w-[480px] -translate-x-1/2 animate-pulseGlow"></div>

      <div className="relative mx-auto max-w-4xl px-4 text-center md:px-8">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/15 bg-background-50/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-accent-300">
            <i className="ri-rocket-2-line" aria-hidden="true"></i>
            Vamos começar
          </span>
          <h2 className="mt-6 font-heading text-3xl font-bold tracking-tight md:text-5xl">
            {solucoesCta.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-background-200 md:text-lg">
            {solucoesCta.description}
          </p>
        </Reveal>

        <Reveal delay={120}>
          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/contato"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-file-list-3-line text-lg" aria-hidden="true"></i>
              Solicitar orçamento
            </Link>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/20 bg-background-50/5 px-6 py-4 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10 sm:w-auto"
            >
              <i className="ri-whatsapp-line text-lg text-secondary-400" aria-hidden="true"></i>
              Falar com a NXHOST
            </a>
          </div>
          <p className="mt-6 inline-flex items-center gap-2 text-sm text-background-300">
            <i className="ri-whatsapp-line text-secondary-400" aria-hidden="true"></i>
            WhatsApp {WHATSAPP_DISPLAY}
          </p>
          <p className="mt-6 border-t border-background-50/10 pt-6 text-xs uppercase tracking-wide text-background-400 md:text-sm">
            {solucoesCta.strip}
          </p>
        </Reveal>
      </div>
    </section>
  );
}